import(/* webpackMode: "eager" */ "/var/www/deemcee-frontend/node_modules/next/dist/client/image-component.js");
